/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createProfile} from '../api'

export const useMutationCreateProfile = createReactQueryMutationHook('createProfile', createProfile)
